<div class="product-header-row" [class.is-long]="isLongMode">
  <!-- Image Section -->
  <div class="image-section pointer" (click)="showFullImage(articleImage || no_image || '')">
    <img
      [src]="articleImage || no_image"
      (error)="onImageError()"
      alt="Item Image"
    />
  </div>
  
  <!-- Info Section -->
  <div class="info-section">
    <div class="price-row">
      <h2 class="price-text">
        {{ precio | integerToFloat | currency: 'USD' : 'symbol' : decimalPrecision }}
      </h2>
      <app-icon iconName="chevron-down" class="ml-2 pointer" *ngIf="shouldShowPriceOptions()"></app-icon>
    </div>
    
    <p class="description-text" *ngIf="articleDescription">
      {{ articleDescription }}
    </p>
    
    <!-- Quantity Selector -->
    <div class="quantity-selector">
      <app-icon 
        [iconName]="quantityDecreaseIcon"
        class="pointer"
        (click)="decreaseMealSelected()">
      </app-icon>
      <span class="qty-text">{{ formGroup.get('cantidad')?.value }}</span>
      <div class="add-btn pointer" (click)="increaseMealSelected()">
        <app-icon iconName="plus" color="white" size="14"></app-icon>
      </div>
    </div>
  </div>
</div>